import { gsap } from "gsap";
import { Power0 } from 'gsap/all';
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import { TweenMax, Power0, Sine } from 'gsap/all';
//import { TimelineMax } from 'gsap/all';
import ScrollMagic from 'scrollmagic';
import {spanWrapAllLetters} from '../../helpers/texthelper';
import {PopInBodyScrollEffect} from '../anim8.effect.scroll.text-popin-section';

export default class Anim8_pirates {


	constructor(scroll, sceneFactory, controller, domElem) {

		if( !domElem ) {
			console.error('DOM ELEMENT FOR NEWS NOT FOUND');
			return;
		}

		this.animatedIn = false;
		this.animatedOut = false;
		this.useScrollTrigger = true;

		this.domElem = domElem;
		this.sceneElemName = this.domElem.getAttribute('data-anchor').toLowerCase();
		this.sceneDuration = this.domElem.getAttribute('data-duration');
		this.sceneOffset = this.domElem.getAttribute('data-offset');
		
		this.dimensions = domElem.getBoundingClientRect();

		//this.setTextLetters();

		this.initTimeline();

		if( ![undefined,null].includes(scroll) && ![undefined,null].includes(controller) ) {
			this.initScrollMagic(scroll, sceneFactory, controller);
		} else {
			//this.defaultTween();
		}

		console.warn("[Anim8_pirates.js] loaded");

		return this.timeline;
		
	}

	initTimeline() {

		this.timeline = gsap.timeline({
			delay: 0,
			defaults: {
				ease: "power1.inOut"
			},
			scrollTrigger: (this.useScrollTrigger === true ? this.scrollTriggerOptions() : false),
			onComplete: () => {
				console.log("Anim8_pirates.js finished");
			},
		});
	}

	scrollTriggerOptions() {

		let initialised = false;

		return {
			trigger: this.domElem,
			pin: false, // pin the trigger element while active
			start: 'top bottom', // when the top of the trigger hits the top of the viewport
			//end: `+=${(this.dimensions.height*.75)}`,
			end: `+=${(this.dimensions.height*1.5)}`,
			//end: `+=${this.dimensions.height + (this.dimensions.height*.25)}`,
			//end: '+=500', // end after scrolling 500px beyond the start
			//end: 'top bottom',
			//toggleActions: "play none none reset",
			scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			/** /
			snap: {
				snapTo: 'labels', // snap to the closest label in the timeline
				duration: { min: 0.2, max: 3 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
				delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
				ease: 'power1.inOut' // the ease of the snap animation ("power3" by default)
			},
			/**/
			//markers: {startColor:"green", endColor:"red", fontSize:"12px"},
			onToggle: self => console.log(`${this.sceneElemName} active:`, self.isActive),
			/** /
			onEnter: (({progress, direction, isActive}) =>{
				if( initialised === false ) {
					this.animatedText = new PopInBodyScrollEffect(this.domElem.querySelector('.text-wrapper'));
					this.animatedText.play();
					initialised = true;
				} else {
					this.animatedText.play();
				}
			}),
			/**/
		}

	}

	initScrollMagic(scroll, sceneFactory, controller) {
	
		this.scrollMagicScene = new ScrollMagic.Scene({
			triggerElement: this.domElem,
			duration: '110%',
			offset:  `-300px`,
			//offset: 0,
			triggerHook: 'onEnter'
		})
		.setTween(this.defaultTween())
		.addTo(controller)
		.setClassToggle( this.domElem, 'active');

		scroll.options.scenes.push(this.scrollMagicScene);
	}

	setTextLetters() {
		const letters = this.domElem.querySelectorAll('.text-wrapper .letters');
		if( letters ) {
			letters.forEach((lettContainer)=>{
				spanWrapAllLetters(lettContainer);
			})
			//this.domLetters = spanWrapAllLetters(letters);
		}
	}

	defaultTween() {

		return this.timeline
		.fromTo(
			this.domElem.querySelectorAll('.letter'), 
			{
				y: '100%',
				//rotationY: -90,
				autoAlpha: 1
			},
			{
				y: '0%',
				//rotationY: 0,
				autoAlpha: 1,
				stagger: .1,
				overwrite: false,
				//immediateRender: false,
				//ease: Power0.easeInOut
				//ease: Power0.easeOut
			},
			
		)
		/*
		.fromTo(
			document.body.querySelectorAll('.carousel-pirates .pirate-item'), 
			{
				//autoAlpha: 0,
				scale: .8,
				translateZ: 0,
			},
			{
				//autoAlpha: 1,
				scale: 1,
				translateZ: 0,
				stagger: {
					amount: 0.1,
					from: 'end'
				},
				//duration: 4,
				overwrite: false,
				//immediateRender: false,
				//ease: Power0.easeInOut,
				ease: Power0.easeOut,
				onComplete: ((evt)=>{
					console.log('CAROUSEL ANIMATE IN COMPLETE');
				}),
			},
			'-=1.5'
		)
		.fromTo(
			document.body.querySelectorAll('.carousel-pirates .pirate-item.is-next'), 
			{
				//autoAlpha: 0,
				scale: .8,
				translateZ: 0,
			},
			{
				//autoAlpha: 1,
				scale: 1,
				translateZ: 0,
				stagger: {
					amount: 0.1,
					from: 'end'
				},
				//duration: 4,
				overwrite: false,
				//immediateRender: false,
				//ease: Power0.easeInOut,
				ease: Power0.easeOut,
				onComplete: ((evt)=>{
					console.log('CAROUSEL ANIMATE IN COMPLETE [NEXT]');
				}),
			},
			'-=1.5'
		)
		/** /
		.fromTo(
			this.domElem.querySelector('.carousel-pirates'), 
			{
				x: '25%',
				//rotationY: -90,
				autoAlpha: 1
			},
			{
				x: '0%',
				//rotationY: 0,
				autoAlpha: 1,
				//stagger: .1,
				duration: 4,
				overwrite: false,
				//ease: Power0.easeInOut
				//immediateRender: false,
				ease: Power0.easeInOut
				//ease: Power0.easeOut
			},
			
		)
		/**/
		/** /
		.fromTo(
			this.domElem.querySelectorAll('.carousel-pirates .pirate-item'), 
			{
				autoAlpha: 1,
				scale: .8,
			},
			{
				autoAlpha: 1,
				scale: 1,
				stagger: {
					amount: 0.15,
					//from: 'start'
				},
				//duration: 4,
				overwrite: false,
				//ease: Power0.easeInOut
				//immediateRender: false,
				//ease: Power0.easeInOut
				ease: Power0.easeOut
			},
			
		),
		'-=1.15'
		/**/
	}

}
